import Slidermodal from './slider-modal';
export default class Slider1 {
   constructor() {
      this.slider = $('[data-slider1]')
      this.init()
   }

   init() {
      if (this.slider.length > 0) {
         this.slider.on('init', function(event, slick, direction) {
            new Slidermodal();
         });

         this.slider.not('.slick-initialized').slick({
            infinite: true,
            dots: false,
            arrows: true,
            autoplay: false,
            slidesToShow: 4,
            speed: 500,
            responsive: [
               {
                  breakpoint: 1366,
                  settings: {
                     slidesToShow: 2,
                  },
               },
               {
                  breakpoint: 768,
                  settings: {
                     slidesToShow: 1,
                  },
               },
            ],
         })
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/slider1.js
// module id = 16
// module chunks = 0